import NextLink from 'next/link';

import { sizeClassnames, variantClassnames } from '@/server/components/Button/helpers';

import css from './Button.module.scss';

type ButtonType = JSX.IntrinsicElements['button']['type'];

/* eslint-disable react/button-has-type */
export const Button = ({
  className,
  type = 'button',
  onClick,
  children,
  variant = 'default',
  size = 'md',
}: {
  className?: string;
  type?: ButtonType;
  onClick: () => void;
  children: React.ReactNode;
  variant: keyof typeof variantClassnames;
  size?: keyof typeof sizeClassnames;
}) => (
  <button
    type={type}
    className={`${css.button} ${variantClassnames[variant]} ${sizeClassnames[size]} ${className || ''}`}
    onClick={onClick}
  >
    {children}
  </button>
);

export const TextButton = ({
  buttonType = 'button',
  onClick,
  children,
}: {
  buttonType?: ButtonType;
  onClick: () => void;
  children: React.ReactNode;
}) => (
  <button type={buttonType} className={css.link}>
    {children}
  </button>
);
/* eslint-enable react/button-has-type */

export const Link = ({
  href,
  disableDarkMode = false,
  variant = 'default',
  children,
}: {
  href: string;
  children: React.ReactNode;
  disableDarkMode?: boolean;
  variant?: keyof typeof variantClassnames;
}) => {
  const linkVersionClass = css.link;
  const respectDarkModeClass = disableDarkMode ? '' : css['respect-dark-mode'];

  return (
    <NextLink
      href={href}
      target="_self"
      className={`${linkVersionClass} ${variantClassnames[variant]} ${respectDarkModeClass}`}
    >
      {children}
    </NextLink>
  );
};
